module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("试音技巧")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.  什么样的试音音频更容易中选呢？")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2.  如何录制一个好音频？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("“工欲善其事，必先利其器”。在开始前，您可能需要了解下录音设备，请参考"), _c('router-link', {
    attrs: {
      "to": {
        name: 'pickEquipment'
      }
    }
  }, [_vm._v("录音设备挑选")]), _vm._v("。"), _c('br'), _vm._v("\n        除了设备外，掌握"), _c('router-link', {
    attrs: {
      "to": {
        name: 'announceTips'
      }
    }
  }, [_vm._v("有声播讲技巧")]), _vm._v("和"), _c('router-link', {
    attrs: {
      "to": {
        name: 'audioPostProgress'
      }
    }
  }, [_vm._v("音频后期方法")]), _vm._v("，也能够帮你录制出优质音频，提高海选中选几率。\n    ")], 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3.  请问手机是否可以参与有声化平台的试音？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("您好，实在抱歉，因为目前没有任何手机能够录制的出192Kbps音质的声音，即使编辑给您通过了，也是很难得到听众的认可的，希望您能够理解。")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("①有专业的录音设备，音频无电流，无杂音，无混响之类，声音不能忽大忽小；"), _c('br'), _vm._v("\n        ②普通话标准，咬字清晰，口齿清楚，断字断句符合规范；"), _c('br'), _vm._v("\n        ③播读有感情，忌朗读课文，试音选段挑选得比较好（有旁白有对话有情节冲突的内容）；"), _c('br'), _vm._v("\n        ④一定要选择适合自己声线的作品；"), _c('br'), _vm._v("\n        ⑤可适当添加后期处理；"), _c('br'), _vm._v("\n        ⑥双人/多人是加分项；"), _c('br'), _vm._v("\n        ⑦闲的时候可以多试几本，增加被选中的概率；"), _c('br'), _vm._v("\n        以上我都达到了，为什么还是没被选中呢？"), _c('br'), _vm._v("\n        这个时候亲就要考虑平时是否经常断更，经常没有按照录制要求录制，经常试音被选中了无故拒绝邀约，录制的作品不符合要求，毫无理由地骚扰编辑，干扰编辑的正常工作等等。\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9fbcbf34!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/AuditionTips.vue
// module id = 359
// module chunks = 0